import React from 'react';
import PropTypes from 'prop-types';

import Advisor from '../../components/investing-advisor';

const InvestingAdvisor = (props) => (
  <Advisor
    tradeName={props.product.tradeName}
    secName={props.product.secName}
    advLink={props.product.advLink}
    href={props.product.destinationUrl}
    showOtherOptions={props.product.showOtherOptions}
    otherOptions={props.product.otherOptions}
    disclaimer={props.product.disclaimer || props.product.slug}
  />
);

InvestingAdvisor.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  product: PropTypes.object.isRequired,
};

export default InvestingAdvisor;
